
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, Observable } from 'rxjs';
import { PayCategoryService } from '../services/pay-category.service';
import { PositionService } from '../services/position.service';
import { PpsUtilityService } from '../services/pps-utility.service';
import { RosterService } from '../services/roster.service';
import { TimesheetBreakdownRuleService } from '../services/timesheet-breakdown-rule.service';
import { PayCategory } from '../shared/models/pay-category';
import { IRosterCode } from '../shared/models/roster-code';
import { Position } from '../shared/models/position';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';
import { ToastService } from '../shared/toast/toast.service';
import { ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash-es';
import { PayCategoryDropdownComponent } from './pay-category-dropdown.component';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { RosterCodeDropdownComponent } from './roster-code-dropdown.component';
import { PositionDropdownComponent } from './position-dropdown.component';
import { BreakdownRuleDropdownComponent } from './breakdown-rule-dropdown.component';
import { BreakdownRuleLockComponent } from './breakdown-rule-lock.component';
import { SubSink } from 'subsink';

@Component({
  selector: 'pps-timesheet-breakdown-rule',
  templateUrl: './timesheet-breakdown-rule.component.html',
  styles: [`
    .ng-select.ng-select-auto-height .ng-select-container{
      height: auto;
      padding:0px;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class TimesheetBreakdownRuleComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  smallScreen = false;
  spinnerName: string = "dataSpinner";
  items: MenuItem[]  = [
    {label:"Settings", icon: "pi-fw fas fa-tools"}, 
    {label:"Manage Payroll Timesheet Rules", icon: "pi-fw fas fa-comment-dollar"}
  ];

  exporting: boolean = false;
  gridHeaders = [];
  context:any = {};
  // modules: Module[] = [
  //   ClientSideRowModelModule
  // ];  

  frameworkComponents: any;
  gridOptions = {
    deltaRowDataMode: true,
    getRowId: param => param.data.id,
    defaultColDef: {
      filter: true,
      sortable: true,
      resizable:true,
      floatingFilter: true,
      cellStyle: this.getCellStyle,
      enableCellChangeFlash: true
    },
    enableCellTextSelection: true,
    ensureDomOrder: true
  };
  private gridApi;

  selectedRow: any = null;
  selectedPositions: Position[] = [];
  selectedRosterCodes: IRosterCode[] = [];
  selectedPayCategories: PayCategory[] = [];

  creatingRule: boolean = false;
  reloading: boolean = false;

  ruleForWeekend: string = "0";
  rule: TimesheetBreakdownRule = new TimesheetBreakdownRule();

  rules: TimesheetBreakdownRule[] = [];
  positions: Position[] = [];
  rosterCodes: IRosterCode[] = [];
  payCategories: PayCategory[] = [];
  // predefinedRulesList:any = null;
  // predefinedRules: any = {
  //   1: {
  //     id: 1, 
  //     name: "input_hour >= 7.6 ? 7.6 : input_hour", 
  //     description: "7.6 hours if the input value is more than 7.6, input value otherwise."
  //   },
  //   2:{
  //     id: 2, 
  //     name: "input_hour < 7.6 ? 0 : input_hour - 7.6",
  //     description: "input value - 7.6 hours if the input value is more than 7.6, 0 otherwise."
  //   },
  //   3:{
  //     id: 3, 
  //     name:"7.6 hours",
  //     description: "7.6 hours."
  //   },
  //   4:{
  //     id: 4, 
  //     name: "input_hour",
  //     description: "input value."
  //   }
  // };
  
  constructor(private _spinner: NgxSpinnerService,
              private _ruleService: TimesheetBreakdownRuleService,
              private _positionService: PositionService,
              private _payCategoryService: PayCategoryService,
              private _rosterService: RosterService,
              private _toast: ToastService,
              private _confirmationService: ConfirmationService,
              public util: PpsUtilityService,
              private breakpointObserver: BreakpointObserver,
              private changeDetectorRef: ChangeDetectorRef) { 
      
    this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
        console.log("smallScreen? " + this.smallScreen);
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.context = { componentParent: this };
    this.frameworkComponents = {
      positionDropdownComponent: PositionDropdownComponent,
      rosterCodeDropdownComponent: RosterCodeDropdownComponent,
      payCategoryDropdownComponent: PayCategoryDropdownComponent,
      breakdownRuleDropdownComponent: BreakdownRuleDropdownComponent
    };    

    this.gridHeaders = this.getColumnDefs();
    this.loadEntities();
  }

  ngAfterViewChecked()
  {
    /*
    add the following line to resolve the ExpressionChangedAfterItHasBeenCheckedError exception
    
    core.js:6185 ERROR Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '0'. Current value: '992'.
        at throwErrorIfNoChangesMode (core.js:8092)
        at bindingUpdated (core.js:19773)
        at interpolation1 (core.js:19917)
        at Module.ɵɵpropertyInterpolate1 (core.js:21981)
        at TimesheetBreakdownRuleComponent_Template (timesheet-breakdown-rule.component.html:55)
        at executeTemplate (core.js:11949)
        at refreshView (core.js:11796)
        at refreshComponent (core.js:13229)
        at refreshChildComponents (core.js:11527)
        at refreshView (core.js:11848)  
    */
    this.changeDetectorRef.detectChanges();
  }  

  onGridReady(params) {
    this.gridApi = params.api;
  }

  onRowClicked(evt){
    let _this = evt.context.componentParent;
    var selectedRows = _this.gridApi.getSelectedRows();
    _this.selectedRow = selectedRows.length === 1 ? selectedRows[0] : null;
  }

  onRowDblClicked($event){
  }

  getLockedCount(){
    return this.rules.filter(r=>r.lock).length;
  }

  getUnlockedCount(){
    return this.rules.filter(r=>!r.lock).length;
  }

  loadRules(){
    this._spinner.show(this.spinnerName);
    this.reloading = true;
    this.subs.sink = this._ruleService.getAll()
      .subscribe(response => {
        if (response.succeed){
          this.rules = response.result;
          this._toast.succeeded(`${this.rules.length} rules have been loaded`);
        }else{
          this._toast.failed("Loading rules failed: " + response.errors.join(";"));
        }
      })
      .add(() => {
        this._spinner.hide(this.spinnerName);
        this.reloading = false;
      });
  }

  loadEntities(){
    this._spinner.show(this.spinnerName);
    this.subs.sink = forkJoin([
      this._rosterService.getRosterCodes(),
      this._positionService.getAll(),
      this._payCategoryService.getAll()
    ]).subscribe(([rcRes, posRes, pcRes]) => { // onNext
      if (rcRes.succeed){
        this.rosterCodes = rcRes.result.filter(rc => rc.canBeUsedInTimesheetBreakdownRule);
        this.selectedRosterCodes = _.cloneDeep(this.rosterCodes);
      }

      if (posRes.succeed){
        this.positions = posRes.result;
      }

      if (pcRes.succeed){
        this.payCategories = pcRes.result;
        this.payCategories.forEach(pc => pc.lowerCaseName = pc.name.toLowerCase());
      }
    }, error => { // onError
    }, () => {  //onComplete
      this.loadRules();
    }).add(() => { //Finalize handler
      this._spinner.hide(this.spinnerName);
    });
  }

  deleteRule(rule){
    this._confirmationService.confirm({
      header: "Delete Breakdown Rule",
      message: `Are you sure that you want to delete selected rule?`,
      icon: "fas fa-exclamation-circle icon-danger",
      key: "dlg1",
      defaultFocus: "accept",
      accept: () => {
        this._deleteRule(rule);
      }
    });
  }

  private _deleteRule(rule){
    this.subs.sink = this._ruleService.delete(rule.id)
    .subscribe(res => {
      if (res.succeed){
        var foundIndex = this.rules.findIndex(x => x.id == rule.id);
        if (foundIndex !== -1){
          this.rules.splice(foundIndex, 1);
          this.gridApi.setRowData(this.rules);

          if (foundIndex < this.rules.length){
            let nextRow = this.gridApi.getRowNode(this.rules[foundIndex].id);
            if (nextRow){
              nextRow.setSelected(true);
              this.selectedRow = nextRow;
            }
          }

          this._toast.succeeded(`Timesheet breakdown rule for position [${rule.position.title}] deleted!`);
        }
      }else{
        this._toast.failed(`Delete timesheet breakdown rule failed: ${res.errors.join(";")}!`);
      }
    });
  }

  addRule(weekend: boolean){
    let rule = new TimesheetBreakdownRule();
    rule.weekend = weekend;
    rule.lock = false;
    rule.active = true;
    this.subs.sink = this._ruleService.add(rule)
      .subscribe(
        res => {
          if (res.succeed){
            this.rules.unshift(res.result);
            this.gridApi.setRowData(this.rules);
            let rowNode = this.gridApi.getRowNode(res.result.id);
            if (rowNode){
              this.gridApi.flashCells({rowNodes: [rowNode]});
              rowNode.setSelected(true);
              this.selectedRow = rowNode;
            }
          }else{
            this._toast.failed(`Add new rule failed: ${res.errors.join(";")}!`);
          }
        },
        error => {}
      )
      .add(()=>{
      });
  }

  updateRule(rule, updateColId, whenSucceeded = null, whenFailed = null, whenError = null, whenDone = null){
    this.subs.sink = this._ruleService.update(rule)
      .subscribe(res => {
        if (res.succeed){          
          var foundIndex = this.rules.findIndex(x => x.id == rule.id);         
                 
          if (foundIndex !== -1){
            let oldRule = this.rules[foundIndex];
            switch (updateColId){
              case "lock":
                oldRule.lock = rule.lock; break;
              case "position":
                oldRule.position = _.cloneDeep(rule.position); break;
              case "roster-code":
                oldRule.rosterCode = _.cloneDeep(rule.rosterCode); break;
              case "pay-category":
                oldRule.payCategory = _.cloneDeep(rule.payCategory); break;
              case "break-down-rule":
                oldRule.breakdownRule = rule.breakdownRule; break;
            }

            this.rules[foundIndex] = oldRule;
            this.gridApi.setRowData(this.rules);
            var rowNode = this.gridApi.getRowNode(rule.id);
            if (updateColId === "lock"){
              // This is to force the cellRendererSelector to switch to new component
              // https://github.com/ag-grid/ag-grid/issues/3086
              this.gridApi.redrawRows({rowNodes: [rowNode]});
            }

            this.gridApi.flashCells({
              rowNodes: [rowNode],
              columns: [updateColId]
            });            
          }

          this._toast.succeeded(`Timesheet breakdown rule for position [${res.result.position.title}] has been updated!`);
          if (whenSucceeded){
            whenSucceeded(res);
          }
        }else{
          this._toast.failed(`Update timesheet breakdown rule failed: ${res.errors.join(";")}!`);

          if (whenFailed){
            whenFailed(res);
          }
        }
    }, error => {
      if (whenError){
        whenError(error);
      }
    }).add(()=>{
      if (whenDone){
        whenDone();
      }
    });
  }

  private getColumnDefs(){
    return [
      // {
      //   colId: "id",
      //   headerName: 'Id',
      //   field:'id',
      //   filter: false,
      //   sortable: true,
      //   resizable: false,
      //   width: 50,
      //   suppressMovable: true,
      //   cellStyle: {textAlign:"center"}
      // },
      {
        colId: "lock",
        headerName: 'Lock',
        field:'lock',
        filter: false,
        width: 70,
        sortable: true,
        cellRenderer: BreakdownRuleLockComponent,
        cellClass: "pps-cell-text-align-center"
      },
      {
        colId: "weekday",
        headerName: 'Weekday',
        field: '',
        width: 100,
        valueGetter: this.getWeekdayValue
      },
      {
        colId: "position",
        headerName: 'Position',
        field:'position.title',
        filter: "agTextColumnFilter",
        width: 220,
        sortable: true,
        cellRendererSelector: params => params.data.lock ? null : {component: "positionDropdownComponent"},
        comparator: (a, b) => this.positionComparator(a, b),
        cellClass: "pps-grid-dropdown"
      },
      {
        colId: "roster-code",
        headerName: 'Roster Code',
        field:'rosterCode.code',
        width: 220,
        filter: true,
        sortable: true,
        cellRendererSelector: params => params.data.lock ? null : {component: "rosterCodeDropdownComponent"},
        comparator: (a, b) => this.rosterCodeComparator(a, b),
        valueGetter: params => {
          return `${params.data.rosterCode?.code} - ${params.data.rosterCode?.description}`;
        }, 
        cellClass: "pps-grid-dropdown"
      },
      {
        colId: "pay-category",
        headerName: 'Pay Category',
        field:'payCategory.name',
        width: 260,
        filter: true,
        sortable: true,
        cellRendererSelector: params => params.data.lock ? null : {component: "payCategoryDropdownComponent"},
        comparator: (a, b) => this.comparator(a, b),
        cellClass: "pps-grid-dropdown"
      },
      {
        colId: "break-down-rule",
        headerName: 'Timesheet Hour Calculation Rule',
        field:'breakdownRule',
        flex: 1,
        filter: true,
        sortable: true,
        cellRendererSelector: params => params.data.lock ? null : {component: "breakdownRuleDropdownComponent"},
        comparator: (a, b) => this.comparator(a, b),
        valueGetter: params => {
          var _this = params.context.componentParent;
          var rules = _this._ruleService.getBreakdownRules();
          return rules[params.data.breakdownRule - 1];
        },
        cellClass: "pps-grid-dropdown"
      }
    ];
  }

  private positionComparator(a, b): number{
    let aValue = a ? (a.title ? a.title : a) : "";
    let bValue = b ? (b.title ? b.title : b) : "";
    return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
  }

  private rosterCodeComparator(a, b): number{
    let aValue = a ? (a.code ? a.code : a) : "";
    let bValue = b ? (b.code ? b.code : b) : "";
    return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
  }

  private comparator(a, b): number{
    let aValue = a ? (a.name ? a.name : a) : "";
    let bValue = b ? (b.name ? b.name : b) : "";
    return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
  }

  private getWeekdayValue(params){
    let rule: TimesheetBreakdownRule = params.data;

    return rule.weekend ? "Weekend" : "Weekday";
  }

  private getCellStyle(params){
    let rule: TimesheetBreakdownRule = params.data;

    if (rule.lock){
      return {color: "#B00020", fontWeight: "normal"};
    }
  }
}
